import React, { SetStateAction, useState } from "react";
import { useFieldArray } from "react-hook-form";
import "./form.scss";

import { useNavigate } from "react-router-dom";
import { useClassNameByLocation } from "hooks/useClassNameByLocation";
import ModalBootstrap from "components/bootstrap/ModalBootstrap";
import { useTranslation } from "react-i18next";
import { ReportInformationFirstStep } from "models/ReportInformationFirstStep";
import VideoAndDetailsStep from "./components/formSteps/VideoAndDetailsStep";
import OffenseLocationStep from "./components/formSteps/OffenseLocationStep";
import FormSummaryStep from "./components/formSteps/FormSummaryStep";

type ReportFormProps = {
  reportDetails?: ReportInformationFirstStep;
  setCurrStep: React.Dispatch<SetStateAction<number>>;
  currStep: number;
};

const ReportForm = ({
  reportDetails,
  setCurrStep,
  currStep,
}: ReportFormProps) => {
  const { t } = useTranslation();
  const formStepsComponenets = [
    VideoAndDetailsStep,
    OffenseLocationStep,
    FormSummaryStep,
  ];

  const [modalShow, setModalShow] = useState(false);
  const navigate = useNavigate();
  const backNavigation = () => {
    if (currStep === 1) {
      navigate(-1);
    } else {
      setCurrStep(currStep - 1);
    }
  };

  const currStepToRender = () => {
    const StepOfFormToRender = formStepsComponenets[currStep - 1];
    return (
      <StepOfFormToRender
        {...{
          setCurrStep,
          currStep,
          useFieldArray,
          setModalShow,
          backNavigation,
          reportDetails,
        }}
      />
    );
  };

  return (
    <>
      <ModalBootstrap
        onHide={() => setModalShow(false)}
        show={modalShow}
        title={t("attentionWontSave")}
        closeButtonText={t("gotIt")}
        dialogClassName="little-modal"
        backNavigation={backNavigation}
      >
        {t("RecommendationToSave")}
      </ModalBootstrap>

      <div className={useClassNameByLocation("readOnlyModeParent")}>
        <div className={useClassNameByLocation()}>{currStepToRender()}</div>
      </div>
    </>
  );
};

export default ReportForm;
